import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || '',
    // instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY || '',
    loggingLevelConsole: 2,
    maxBatchInterval: 0,
    disableFetchTracking: false,

    // Enhanced error tracking
    autoTrackPageVisitTime: true,
    enableUnhandledPromiseRejectionTracking: true,
    enableAutoRouteTracking: true,
    disableExceptionTracking: false,

    // Improved telemetry
    enableCorsCorrelation: false,
    correlationHeaderExcludedDomains: [
      'royaltyrange-demo.eu.auth0.com',
      '*.applicationinsights.azure.com',
    ],
    distributedTracingMode: DistributedTracingModes.AI_AND_W3C,

    // Console error capture
    enableDebug: true,

    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: null },
    },
  },
});

appInsights.loadAppInsights();

// Add custom error handler
window.addEventListener('error', (event) => {
  appInsights.trackException({
    exception: event.error || event.message,
    severityLevel: 3,
  });
});

// Add unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  appInsights.trackException({
    exception: event.reason instanceof Error ? event.reason : new Error(event.reason),
    severityLevel: 3,
  });
});

export { appInsights, reactPlugin };
